import styled from "styled-components";
import { responsiveMap } from "../../../Grid/_utils/responsiveObserve";

const decorationTopSpace = 90;
export const _LandingAboutMargauxMotinRoot = styled.div`
  width: 100%;
  position: relative;
  overflow: hidden;
  margin-bottom: -44px;

  .landing-about__inner-wrapper {
    @media ${responsiveMap.mobile} {
      gap: 0px;
      flex-direction: column;
    }
  }

  .girl-opening-box-decoration {
    @media ${responsiveMap.mobile} {
      display: none;
    }
  }

  .landing-about__container.without-image
    .landing-about__description__container {
    max-width: 438px;
    position: relative;

    .sushishop-x-margaux-motin-decoration {
      margin-bottom: 28px;
      @media ${responsiveMap.mobile} {
        max-width: 266px;
        margin: 0 auto;
      }
    }
  }
  .skateboarding-decoration {
    margin-top: ${decorationTopSpace}px;
    @media ${responsiveMap.mobile} {
      margin-top: 0;
      transform: translateY(-5%);
      max-width: 212px;
      margin-left: auto;
    }
  }
`;
